// eslint-disable-next-line no-unused-vars
import React from 'react'

import useServerSentEvents from '../hooks/useServerSentEvents'

const SSEManager = () => {
  useServerSentEvents()
  return null
}

export default SSEManager
